<template>
  <div :class="['price-list-item-fi', `price-list-item-fi--${theme}`]">
    <div
      v-if="!isEditMode"
      class="price-list-item-fi__heading"
    >
      {{ fields.heading?.value }}
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-else
      class="price-list-item-fi__heading"
      v-html="fields.heading.editable"
    />
    <!-- eslint-enable vue/no-v-html -->
    <div class="price-list-item-fi__features">
      <price-list-item-feature-fi
        v-for="feature in features"
        :key="feature.id"
        :feature="feature"
        :light="theme === 'highlighted'"
      />
    </div>
    <div
      v-if="!isEditMode && fields.footer?.value"
      class="price-list-item-fi__footer"
    >
      {{ fields.footer.value }}
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-if="isEditMode"
      class="price-list-item-fi__footer"
      v-html="fields.footer.editable"
    />
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script>
import PriceListItemFeatureFi from './price-list-item-feature-fi/PriceListItemFeatureFi';

export default {
  name: 'PriceListFi',
  components: {
    PriceListItemFeatureFi,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    features() {
      return Object.entries(this.fields)
        .filter(([textFieldName]) => textFieldName.startsWith('featureText'))
        .map(([textFieldName, textField]) => {
          const index = (textFieldName.match(/(\d+)/g) || [])[0];
          const checkField = this.fields[`featureCheck${index}`];
          return {
            id: index,
            text: textField.value,
            checked: checkField ? Boolean(checkField.value) : false,
            editable: textField.editable,
          };
        });
    },
    footer() {
      return this.fields.footer ? this.fields.footer.value : null;
    },
    theme() {
      // This can be "default", "highlighted" or "dark".
      return this.fields.theme ? this.fields.theme.value : 'default';
    },
  },
};
</script>

<style scoped lang="scss">
@import './price-list-item-fi';
</style>
